import * as React from 'react';
import * as style from './OtherDevelopersWrapper.css';
import { Responsive, UIHeading1, UIHeading2 } from '@cian/ui-kit';
import { VerticalSlider } from '../VerticalSlider';

export const OtherDevelopersWrapper = ({ children }: React.PropsWithChildren) => {
  return (
    <section id="other-developers" className={style['wrapper']} data-testid="OtherDevelopers">
      <Responsive desktop>
        <UIHeading1>Другие застройщики</UIHeading1>
      </Responsive>
      <Responsive phone tablet>
        <UIHeading2>Другие застройщики</UIHeading2>
      </Responsive>
      <VerticalSlider arrowOffset={0}>{children}</VerticalSlider>
    </section>
  );
};
